import { motion } from "framer-motion";
import { useRef } from "react";

const profiles = [
    { id: 1, image: "/profile_teacher_1.png", name: "Sarah", age: 28, role: "Teacher" },
    { id: 2, image: "/profile_male_1.png", name: "Mike", age: 32, role: "Engineer" },
    { id: 3, image: "/profile_teacher_2.png", name: "Jessica", age: 30, role: "Teacher" },
    { id: 4, image: "/profile_male_2.png", name: "David", age: 29, role: "Architect" },
    { id: 5, image: "/profile_teacher_1.png", name: "Emily", age: 27, role: "Teacher" },
    { id: 6, image: "/profile_male_1.png", name: "James", age: 34, role: "Doctor" },
];

export function HeroCarousel() {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div className="w-full h-full overflow-hidden relative flex items-center justify-center">
            {/* Diagonal Container */}
            <motion.div
                ref={containerRef}
                className="flex gap-6 cursor-grab active:cursor-grabbing p-10"
                style={{
                    transform: "skewY(-5deg)", // The Bumble diagonal tilt
                }}
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                drag="x"
                dragConstraints={{ right: 0, left: -1000 }} // Adjust based on content width
                whileTap={{ cursor: "grabbing" }}
            >
                {profiles.map((profile) => (
                    <motion.div
                        key={profile.id}
                        className="flex-shrink-0 w-72 h-96 relative rounded-3xl overflow-hidden shadow-2xl bg-white"
                        whileHover={{ scale: 1.02, rotate: 0, zIndex: 10 }}
                        transition={{ duration: 0.2 }}
                        style={{
                            // Counter-skew images if we want them upright, 
                            // or keep them skewed for the full effect. 
                            // Bumble keeps them skewed usually or the container is skewed.
                            // Let's keep the card skewed with the container for now.
                        }}
                    >
                        <img
                            src={profile.image}
                            alt={profile.name}
                            className="w-full h-full object-cover"
                            draggable={false}
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6 text-white">
                            <h3 className="font-bold text-2xl">
                                {profile.name}, {profile.age}
                            </h3>
                            <p className="text-base opacity-90 font-medium">{profile.role}</p>
                        </div>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    );
}
